export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9678.1c4db4a1.jpg";